import {
  addUhidToAppointment,
  queueFilterInlineSearchKeys,
  useFuseSearch,
} from "@elixir/utils";
import React from "react";
import { getFilteredAppointmentList } from "ui";
import useAllQueuesQuery from "../../apis/tryst/get-all-queues";
import { QUEUE_TYPE } from "../../constants/appointments";
import useQueueStore from "../../stores/queue-store";
import LeftQueueContainer from "./left-queue-container";
import { getAptsForDoctor } from "../../utils/appointment-utils";

const Booked = () => {
  const { data, isLoading } = useAllQueuesQuery({
    queueType: "bookedAppointments",
  });

  const leftQueueFilter = useQueueStore((state) => state.leftQueueFilter);
  const selectedDoctor = useQueueStore((state) => state.selectedDoctor);

  const _filteredData = React.useMemo(() => {
    return (
      getFilteredAppointmentList({
        appointments: getAptsForDoctor({
          apts: data?.bookedAppointments || [],
          doctor_oid: selectedDoctor?.oid,
        }),
        queueFilter: leftQueueFilter,
        queueType: QUEUE_TYPE.BOOKED,
      }) || []
    );
  }, [data?.bookedAppointments, selectedDoctor?.oid, leftQueueFilter]);

  const leftSearchQuery = useQueueStore((state) => state.leftSearchQuery);
  const filteredApts =
    useFuseSearch(
      leftSearchQuery,
      addUhidToAppointment(_filteredData || []),
      queueFilterInlineSearchKeys
    ) || [];

  return (
    <LeftQueueContainer
      isLoading={isLoading}
      queueApts={filteredApts}
      queueType={QUEUE_TYPE.BOOKED}
    />
  );
};

export default Booked;
